import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/auth";
import { useHomeContext } from "../../context/HomeContext";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { useThemeContext } from "../../context/ThemeContext";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
const Ads = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { currentMode } = useThemeContext();
  const [adsData, setAdsData] = useState([]);
  const [acceptedAds, setAcceptedAds] = useState([]);
  const [rejectedAds, setRejectedAds] = useState([]);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const adsDatas = useQuery(
    ["adsDataApi"],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}ads/all`, {
        headers,
      }),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setAdsData(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );

  //accepted ads
  const acceptedAdsData = useQuery(
    ["acceptedAdsDataApi"],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}ads/accepted`, {
        headers,
      }),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setAcceptedAds(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
  //rejected ads 
  const rejectedAdsData = useQuery(
    ["rejectedAdsDataApi"],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}ads/all/rejected`, {
        headers,
      }),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setRejectedAds(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
  const columns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "images",
      headerName: "Image",
      width: 100,
      renderCell: (params) => {
        return (
          <img
            src={params?.row?.images[0]}
            alt=""
            className="h-10 w-full object-cover rounded-md"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },

    {
      field: "price",
      headerName: "price",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "type",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isFeatured",
      headerName: "isFeatured",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 200,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <div className="flex items-center space-x-3">
            <Link to={"/ads/detail/" + params.row._id}>
              <button
                className="bg-blue-bg rounded-sm text-center
                     px-3 p-1 font-medium text-sm text-white capitalize"
              >
                Detail
              </button>
            </Link>
          </div>
        );
      },
    },
  ];

  //acceptd
  const acceptedColumns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "images",
      headerName: "Image",
      width: 100,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <img
            src={params?.row?.images[0]}
            alt=""
            className="h-10 w-full object-cover rounded-md"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 200,
      renderCell: (params) => {
        return <h1>{params.row.owner.name}</h1>;
      },
    },
    {
      field: "price",
      headerName: "price",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "type",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isFeatured",
      headerName: "isFeatured",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isAccepted",
      headerName: "isAccepted",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
  ];
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        // color="secondary"
        // variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  return (
    <div className="p-3 md:p-5">
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        <div className="flex items-center justify-between py-4">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Ads/Request
          </h1>
        </div>
        {/*  properties*/}
        {adsDatas.isFetched ? (
          adsDatas?.data?.data?.data?.length > 0 ? (
            adsData?.length > 0 ? (
              <div style={{ height: 520 }} className="">
                <DataGrid
                  rows={adsData}
                  columns={columns}
                  pageSize={8}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  getRowId={(row) => row._id}
                  sx={{
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    "& .super-app-theme--header": {
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      border: "none",
                    },
                    color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                    border: 2,
                    borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                    [`& .${gridClasses.cell}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                    },
                    [`& .${gridClasses.row}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-cellCenter": {
                      justifyContent: "center",
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell": {
                      outline: "none",
                      textAlign: "left",
                      border: "none",
                    },
                    "& .MuiPaginationItem-root": {
                      color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                      // backgroundColor:'red'
                      border: "none",
                    },
                  }}
                  components={{
                    Pagination: CustomPagination,
                  }}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )
          ) : (
            <div className="flex items-center justify-center w-full text-center">
              <h1
                className="capitalize text-dark-gray text-2xl
               font-bold text-center"
              >
                You have no Ad request
              </h1>
            </div>
          )
        ) : (
          <div className="flex items-center justify-center">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}
        {/* accepted ads */}
        <div className="pt-5">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl pb-2">
            Accepted Ads
          </h1>

          {acceptedAdsData.isFetched ? (
            acceptedAdsData?.data?.data?.data?.length > 0 ? (
              acceptedAds?.length > 0 ? (
                <div style={{ height: 520 }} className="">
                  <DataGrid
                    rows={acceptedAds}
                    columns={acceptedColumns}
                    pageSize={8}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "& .super-app-theme--header": {
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        border: "none",
                      },
                      color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                      border: 2,
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      [`& .${gridClasses.cell}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                      },
                      [`& .${gridClasses.row}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cellCenter": {
                        justifyContent: "center",
                      },
                      "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        outline: "none",
                        textAlign: "left",
                        border: "none",
                      },
                      "& .MuiPaginationItem-root": {
                        color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                        // backgroundColor:'red'
                        border: "none",
                      },
                    }}
                    components={{
                      Pagination: CustomPagination,
                    }}
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#216fed"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-center">
                <h1
                  className="capitalize text-dark-gray text-2xl font-bold 
              text-center"
                >
                  You have no Accepted Ad yet
                </h1>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
        </div>
      {/* rejected ads request */}
      <div className="pt-5">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl pb-2">
            Rejected Ads
          </h1>

          {rejectedAdsData.isFetched ? (
            rejectedAdsData?.data?.data?.data?.length > 0 ? (
              rejectedAds?.length > 0 ? (
                <div style={{ height: 520 }} className="">
                  <DataGrid
                    rows={rejectedAds}
                    columns={acceptedColumns}
                    pageSize={8}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "& .super-app-theme--header": {
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        border: "none",
                      },
                      color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                      border: 2,
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      [`& .${gridClasses.cell}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                      },
                      [`& .${gridClasses.row}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cellCenter": {
                        justifyContent: "center",
                      },
                      "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        outline: "none",
                        textAlign: "left",
                        border: "none",
                      },
                      "& .MuiPaginationItem-root": {
                        color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                        // backgroundColor:'red'
                        border: "none",
                      },
                    }}
                    components={{
                      Pagination: CustomPagination,
                    }}
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#216fed"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-center">
                <h1
                  className="capitalize text-dark-gray text-2xl font-bold 
              text-center"
                >
                  You have no Accepted Ad yet
                </h1>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Ads;
